<template>
    <label for="rw-select2-zipcodes" class="rwfc rwfc--select2">
        <span class="sr-only">Selected Zipcodes</span>
        <select 
            name="zipcodes[]" 
            id="rw-select2-zipcodes" 
            class="select2" 
            ref="select"
            v-model="selected"
            multiple
            autocomplete="nope">
        </select>
    </label>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    props: [
        'zipcodes',
        'value',
        'selected',
    ],
    methods: {
        getValuesFromMultiSelect(select){
            var result = [];
            var options = select && select.options;
            var opt;

            for (var i=0, iLen=options.length; i<iLen; i++) {
                opt = options[i];

                if (opt.selected) {
                    result.push(opt.value || opt.text);
                }
            }
            return result;
        },
        formatResults (result) {
            return result.text;
        }
    },
    data() {
        const vm = this;
        return {
            debug: true,
            changing: false,
            initialized: false,
            selected_zipcodes: []
        };
    },
    computed: {
        config() {
            const vm = this;
            return {
                minimumInputLength: 2,
                // templateResult: vm.formatResults,
                multiple: true,
                ajax: {
                    type: 'GET',
                    delay: 500,
                    url: '/zipcodes',
                    dataType: 'json',
                    language: { 
                        inputTooShort: function () { 
                            return 'testng'; 
                        } 
                    },
                    data: function (params) {
                        return {
                            term: params.term // search term
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data.map(result => {
                                return {
                                    id: result.id,
                                    text: result.id
                                };
                            })
                        };
                    },
                    error: function (jqXHR, status, error) {
                        return {results: []};
                    }
                }
            };
        }
    },
    mounted() {
        var vm = this;
        $(this.$refs.select)
            // init select2
            .select2(this.config)
            .val(this.value)
            .trigger('change')
            // emit event on change.
            .on('change', function () {
                if(vm.changing){
                    vm.changing = false;
                    return false;
                }
                vm.initialized = true;
                let newVal = $(this).val();
                if(newVal == null){
                    newVal = [];
                }
                vm.$emit('input', newVal);
            });


        for(let index in this.selected){
            if(this.selected[index] == '') continue;
            let option = new Option(this.selected[index], this.selected[index], true, true);
            vm.$refs.select.append(option);
            // vm.$refs.select.trigger('change');
        }

    },
    watch: {
        selected(value){
            const vm = this;
            vm.changing = true;


            for(let index in vm.selected){
                
                let valuesArray = vm.getValuesFromMultiSelect(vm.$refs.select);
                if(vm.selected[index] == '' || valuesArray.includes(vm.selected[index])) continue;
                
                let option = new Option(vm.selected[index], vm.selected[index], true, true);
                vm.$refs.select.append(option);

            }

            $(vm.$refs.select).select2(vm.config).val(value).trigger('change');
            
            return value;

        }
    }
};
</script>

<style>

</style>
